/* *
 * ========================================================================
 * Vortex Solution
 * ========================================================================
 * */

// Includes the custom Modernizr build based on the configurations set in .modernizrrc
require('Modernizr'); // eslint-disable-line import/no-extraneous-dependencies
require('nodelist-foreach-polyfill');
require('element-qsa-scope');
require('./main/dropdown-menu');
require('./main/mobile-menu');
require('./main/user-is-tabbing');
require('./main/forms');
require('./main/search-modal');

import vtxDomReady from './common/helpers';
import Swiper from 'swiper/bundle';
import AOS from 'aos/dist/aos.js';

window.Swiper = Swiper;

vtxDomReady(() => {
  AOS.init({
    startEvent: 'load',
  });
});
